import { combineReducers } from "redux";
import settingReducer from "./slice/settings_slice";
import invoiceReducer from "./slice/invoice_template_slice";

export const rootReducer = combineReducers({
  settingReducer,
  invoiceReducer,
});
